import { io, Socket } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_WS || "http://localhost:8000";

let socket: Socket | null = null;

export function getSocket() {
  if (!socket) {
    socket = io(SOCKET_URL, {
      withCredentials: true,
      transports: ["websocket"],
    });
  }
  return socket;
}
